import React, { useState, useEffect } from 'react';
import { useStripe, useElements, PaymentElement,  Elements, CardElement } from '@stripe/react-stripe-js';
import {eventPayment, eventLocationColorVeryDarkGrey, eventHeader, eventLocationColorDarkGrey, eventEmailInput, eventDiv, eventDetailPrice,  eventDetail, eventRegisterButton, eventLearnMoreButton, eventCancel, eventPaymentLabel, eventCard, eventEmail, eventLocation, eventDate, eventTitle, eventModal, eventModalTitle, eventModalButton, eventLabel, eventText, eventModalDetails} from './styles';
import { loadStripe } from '@stripe/stripe-js';
import { useNavigate } from 'react-router';

const API_BASE = '/api';

export const EventRegistrationModal = ({ 
    selectedEvent,
    email,
    name,
    company,
    onClose,
    onSuccess,
    setEmail,
    setName,
    setCompany,
    showNotification,
    setModalOpen,
    paymentSection
}) => {
    const stripe = useStripe();
    const elements = useElements();
    const [rsvpInProgress, setRsvpInProgress] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    const isFree = selectedEvent.price === "Free" || parseFloat(selectedEvent.price.replace("£", "")) === 0;

    const handleRSVPSubmit = async () => {
        if (!email.trim() || !name.trim()) {
            showNotification('Please enter your email address');
            return;
        }

        // Free Event → just RSVP
        if (isFree) {
            try {
                setRsvpInProgress(true);
                const response = await fetch(`${API_BASE}/rsvp`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        event_id: selectedEvent.id,
                        email,
                        names: name,
                        company,
                        price: selectedEvent.price,
                        paymentIntentId: "" // no payment for free events
                    })
                });

                if (response.ok) {
                    showNotification('Free event registration successful!', 'success');
                    setModalOpen(false);
                } else {
                    const errorData = await response.json();
                    showNotification(errorData.detail || 'Failed to RSVP', 'error');
                }
            } catch (err) {
                showNotification('Registration failed. Please try again.', 'error');
            } finally {
                setRsvpInProgress(false);
            }
            return;
        }

            // Paid Event → Stripe Payment Flow
        if (!stripe || !elements) {
            showNotification('Stripe has not loaded yet', 'error');
            return;
        }

        setIsProcessing(true);
        
        try {
            // 1. Create payment intent
            const result = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: window.location.href,
                },
                redirect: "if_required",
            });

            if (result.error) {
                console.log(result);
                showNotification(result.error.message, 'error');
            } else if (result.paymentIntent.status === 'succeeded') {
            // 3. Finalize RSVP
                const rsvpResponse = await fetch(`${API_BASE}/rsvp`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        event_id: selectedEvent.id,
                        email,
                        names: name,
                        company,
                        price: selectedEvent.price,
                        paymentIntentId: result.paymentIntent.id,
                    }),
                });
                console.log(rsvpResponse);
                if (rsvpResponse.ok) {
                    showNotification('Paid event registration successful!', 'success');
                    setModalOpen(false);
                } else {
                    showNotification('Event RSVP failed after payment', 'error');
                }
            }
        } catch (err) {
            showNotification('Payment processing failed', 'error');
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div style={eventModal} onClick={onClose}>
          <div style={eventModalTitle} onClick={(e) => e.stopPropagation()}>
            
            <button
              style={eventModalButton}
              onClick={onClose}
            >
              ×
            </button>

            <div style={{ marginBottom: '2rem' }}>
              <h3 style={eventLabel}>
                Register for Event
              </h3>
              <p style={eventText}>
                Please provide your details to complete your registration
              </p>
            </div>

            {selectedEvent && (
              <div style={eventModalDetails}>
                <h4 style={eventTitle}>
                  {selectedEvent.title}
                </h4>
                <p style={eventDate}>
                  📅 {selectedEvent.date} • 🕐 {selectedEvent.time}
                </p>
                <p style={eventLocation}>
                  📍 {selectedEvent.location}
                </p>
              </div>
            )}

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={eventEmail}>
                Email Address *
              </label>
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={eventEmailInput}
                onFocus={(e) => e.target.style.borderColor = '#006C35'}
                onBlur={(e) => e.target.style.borderColor = '#e1e1e1'}
                placeholder="your.email@company.com"
              />
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={eventEmail}>
                Full Name
              </label>
              <input
                required
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={eventEmailInput}
                onFocus={(e) => e.target.style.borderColor = '#006C35'}
                onBlur={(e) => e.target.style.borderColor = '#e1e1e1'}
                placeholder="Your full name"
              />
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <label style={eventEmail}>
                Company
              </label>
              <input
                type="text"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                style={eventEmailInput}
                onFocus={(e) => e.target.style.borderColor = '#006C35'}
                onBlur={(e) => e.target.style.borderColor = '#e1e1e1'}
                placeholder="Your company name"
              />
            </div>

            {paymentSection}

            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button 
                style={eventCancel}
                onClick={onClose}
                disabled={rsvpInProgress}
              >
                Cancel
              </button>
              <button 
                style={{
                  ...eventPayment,
                  cursor: email.trim() ? 'pointer' : 'not-allowed',
                  background: email.trim() ? 'linear-gradient(135deg, #006C35, #00a84f)' : '#ccc',
                  boxShadow: email.trim() ? '0 4px 15px rgba(0,108,53,0.3)' : 'none'
                }}
                onClick={handleRSVPSubmit}
                disabled={!email.trim() || !name.trim() || rsvpInProgress}
              >
                {rsvpInProgress ? 'Registering...' : 'Register Now'}
              </button>
            </div>
          </div>
        </div>
    );
};

const EventsPage = ({ showNotification }) => {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const API_BASE = '/api';
  const [clientSecret, setClientSecret] = useState(null);
  const navigate = useNavigate();

  const stripePromise = loadStripe('pk_live_51S5uZQPcIirE4Ow6UHQQfFxYLQtsfLP45c3MNWk21IImtIWIDinfSDSQ5jgnOV1p8g2b0hbMdZ3rkrOsZGoXTp6200XSaFNZKB');

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE}/events`);
      const data = await response.json();
      setEvents(data);
    } catch (error) {
      console.error('Error fetching events:', error);
      showNotification('Error loading events', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleRegisterClick = async (event) =>  {
    const isFree = event.price === "Free" || parseFloat(event.price.replace("£", "")) === 0;
    if (isFree) {
        setSelectedEvent(event);
        setModalOpen(true);
        return;
    }
    try {
        const response = await fetch(`${API_BASE}/create-payment-intent-event`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                    amount: parseFloat(event.price.replace('£', '')) * 100,
                    eventId: event.id,
                    event: event.title,
                    attendeeDetails: {}
                }),
        });
        const data = await response.json();
        setClientSecret(data.clientSecret);
        setSelectedEvent(event);
        setModalOpen(true);
    } catch (err) {
        console.error('Error creating payment intent:', err);
        showNotification('Failed to initialize payment.', 'error');
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedEvent(null);
    setClientSecret(null);
    setEmail('');
    setName('');
    setCompany('');
  };

  return (
    <div style={{ fontFamily: 'system-ui, sans-serif', background: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <section style={eventHeader}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '700', margin: '0 0 1rem 0' }}>
            Events & Networking
          </h1>
          <p style={{ fontSize: '1.3rem', opacity: '0.9', margin: 0 }}>
            Join our exclusive events designed to foster Saudi-British business connections
          </p>
        </div>
      </section>

      
      
        // Your existing events list
            <section style={{ padding: '4rem 0' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '4rem', fontSize: '1.2rem', color: '#666' }}>
                    Loading events...
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '3rem' }}>
                    {events.map(event => (
                        <div key={event.id} style={eventDiv}>
                        <img
                            src={event.image_url}
                            alt={event.title}
                            style={{ width: '100%', height: '300px', objectFit: 'cover' }}
                        />
                        <div style={{ padding: '2.5rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                            <span style={eventDetailPrice}>
                                {event.event_type}
                            </span>
                            <span style={{ fontSize: '1.8rem', fontWeight: '700', color: '#006C35' }}>
                                {event.price}
                            </span>
                            </div>
                            
                            <h3 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '1.5rem', color: '#333' }}>
                            {event.title}
                            </h3>
                            
                            <div style={eventDetail}>
                            <div style={eventLocationColorDarkGrey}>
                                <strong style={eventLocationColorVeryDarkGrey}>📅 Date:</strong> {event.date}
                            </div>
                            <div style={eventLocationColorDarkGrey}>
                                <strong style={eventLocationColorVeryDarkGrey}>🕐 Time:</strong> {event.time}
                            </div>
                            <div style={eventLocationColorDarkGrey}>
                                <strong style={eventLocationColorVeryDarkGrey}>📍 Location:</strong> {event.location}
                            </div>
                            </div>
                            
                            <p style={{ color: '#666', lineHeight: '1.7', marginBottom: '2rem', fontSize: '1.1rem' }}>
                            {event.description}
                            </p>
                            
                            <div style={{ display: 'flex', gap: '1rem' }}>
                            {event.has_happened ? <div></div> : <button
                                style={eventRegisterButton}
                                onClick={() => handleRegisterClick(event)}
                                onMouseOver={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 20px rgba(0,108,53,0.4)';
                                }}
                                onMouseOut={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 15px rgba(0,108,53,0.3)';
                                }}
                            >
                                Register Now
                            </button> }
                            <button  onClick={() => navigate(`/events/${event.id}`)}
                            style={eventLearnMoreButton}>
                                Learn More
                            </button>
                            </div>
                        </div>
                        </div>
                    ))}
                    </div>
                )}
                </div>
            </section>

      {/* Registration Modal */}
      { modalOpen && (
        selectedEvent.price === "Free" || parseFloat(selectedEvent.price.replace("£", "")) === 0 ? (
                        <Elements stripe={stripePromise} >
                                <EventRegistrationModal stripe={stripePromise}
                                                selectedEvent={selectedEvent}
                                                email={email}
                                                name={name}
                                                company={company}
                                                onClose={handleModalClose}
                                                onSuccess={handleModalClose}
                                                setEmail={setEmail}
                                                setName={setName}
                                                setCompany={setCompany}
                                                showNotification={showNotification}
                                                setModalOpen={setModalOpen}
                                                paymentSection={<div></div>}
                                />
                        </Elements>
         ) : (clientSecret && (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
                    <EventRegistrationModal 
                            selectedEvent={selectedEvent}
                            email={email}
                            name={name}
                            company={company}
                            onClose={handleModalClose}
                            onSuccess={handleModalClose}
                            setEmail={setEmail}
                            setName={setName}
                            setCompany={setCompany}
                            showNotification={showNotification}
                            setModalOpen={setModalOpen}
                            paymentSection={
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
                                        Card Details
                                    </label>
                                    <div style={{ padding: '1rem', border: '2px solid #e1e1e1', borderRadius: '10px', marginBottom: '1rem' }}>
                                        <PaymentElement />
                                    </div>
                                </div>
                            }
                    />
            </Elements> 
         )
        )
      )}
    </div>
  );
};

export default EventsPage;